import { selectPatientSplitRestricted } from './patientSplit';

let lastInputs = [];
let lastResult;
const selectSelectedRecordDetails = (state) => {
  const { records } = state;
  const details = records.selectedRecordDetails;
  const restricted = selectPatientSplitRestricted(state);
  const automatic = records.hasAutomaticPatientSplit;
  const inputs = [details, restricted, automatic, records.canEditPatientInfo, records.canEditPrivacyLevel];
  if (inputs.length === lastInputs.length && inputs.every((value, index) => value === lastInputs[index])) return lastResult;
  lastInputs = inputs;
  // The inbox row may still describe the held original after a live handoff.
  // Keep the viewer's actual permissions, then apply the current ownership guard.
  lastResult = restricted || automatic ? {
    ...details,
    patient_split_restricted: restricted,
    can_edit_patient_info: !restricted && records.canEditPatientInfo,
    can_edit_privacy_level: !restricted && records.canEditPrivacyLevel,
  } : details;
  return lastResult;
};

export default selectSelectedRecordDetails;
